import React from "react";
import { Container, Stack, Title } from "@mantine/core";
import MediaGrid from "./MediaGrid";

const Media: React.FC = () => {
  return (
    <Container size="lg" py="xl" pb={250}>
      <Stack gap="lg">
        <Title order={1}>Media</Title>
        <MediaGrid />
      </Stack>
    </Container>
  );
};

export default Media;
